import { PoStorageService } from '@po-ui/ng-storage';

export interface IFiltroCarregamentosME {
  lastSetDefault: Date;

  DZ07DATINC_DE: Date | undefined;
  DZ07DATINC_ATE: Date | undefined;
  CZ07CODIGO: string;
  CZ07STATUS: string;
}

export class FiltroCarregamentosME {

  dados: IFiltroCarregamentosME;
  storageName: string;

  constructor(private poStorageService: PoStorageService) {

    this.dados = this.setDefault();
    this.storageName = 'interface-filtro-carregamentos-me';

    this.poStorageService.get(this.storageName).then((filtro: IFiltroCarregamentosME) => {
      if (filtro) {

        const {
          lastSetDefault,
          DZ07DATINC_DE,
          DZ07DATINC_ATE
        } = filtro;

        if (!lastSetDefault && (new Date().getDay() - new Date(lastSetDefault).getDay())) {
          this.dados = this.setDefault();
        } else {
          this.dados = {
            ...filtro,
            lastSetDefault: new Date(lastSetDefault),
            DZ07DATINC_DE: DZ07DATINC_DE ? new Date(DZ07DATINC_DE) : undefined,
            DZ07DATINC_ATE: DZ07DATINC_ATE ? new Date(DZ07DATINC_ATE) : undefined,
          };
        }
      }
    });
  }

  public setDefault = (): IFiltroCarregamentosME => {
    return {
      lastSetDefault: new Date(),
      DZ07DATINC_DE: this.getData(-7),
      DZ07DATINC_ATE: new Date(),
      CZ07CODIGO: '',
      CZ07STATUS: '',
    };
  }

  public setStorage = (): void => {
    this.poStorageService.set(this.storageName, this.dados);
  }

  private getData = (dias: number): Date => {
    const dataDe = new Date();
    dataDe.setDate(dataDe.getDate() + dias);
    return dataDe;
  }

}
